const CONSENT_STORAGE_KEY = "slam_cookie_consent";
const CONSENT_STATUS_ACCEPTED = "accepted";
const CONSENT_STATUS_REJECTED = "rejected";
const CONSENT_STATUS_UNSET = "unset";
const CONSENT_EVENT_NAME = "slam:consent-updated";
const ANALYTICS_COOKIE_PREFIXES = ["_ga", "_gid", "_gat", "_gac_"];

const deleteCookie = (name) => {
  const expires = "Thu, 01 Jan 1970 00:00:00 GMT";
  const pathCandidates = ["/", window.location.pathname || "/"];
  const domainCandidates = [null, window.location.hostname];

  pathCandidates.forEach((path) => {
    domainCandidates.forEach((domain) => {
      let cookie = `${name}=; expires=${expires}; max-age=0; path=${path}`;

      if (domain) {
        cookie += `; domain=${domain}`;
      }

      document.cookie = cookie;
    });
  });
};

const clearAnalyticsCookies = () => {
  if (typeof document === "undefined") {
    return;
  }

  const cookieNames = document.cookie
    .split("; ")
    .map((cookie) => cookie.split("=")[0])
    .filter(Boolean);

  cookieNames.forEach((name) => {
    if (ANALYTICS_COOKIE_PREFIXES.some((prefix) => name.startsWith(prefix))) {
      deleteCookie(name);
    }
  });
};

const getConsentStatus = () => {
  try {
    const storedValue = window.localStorage.getItem(CONSENT_STORAGE_KEY);

    if (storedValue === CONSENT_STATUS_ACCEPTED || storedValue === CONSENT_STATUS_REJECTED) {
      return storedValue;
    }

    return CONSENT_STATUS_UNSET;
  } catch {
    return CONSENT_STATUS_UNSET;
  }
};

const setConsentStatus = (status) => {
  if (
    status !== CONSENT_STATUS_ACCEPTED &&
    status !== CONSENT_STATUS_REJECTED &&
    status !== CONSENT_STATUS_UNSET
  ) {
    return;
  }

  try {
    if (status === CONSENT_STATUS_UNSET) {
      window.localStorage.removeItem(CONSENT_STORAGE_KEY);
    } else {
      window.localStorage.setItem(CONSENT_STORAGE_KEY, status);
    }
  } catch {
    // Ignore storage failures and continue with in-memory flow.
  }

  if (status === CONSENT_STATUS_REJECTED) {
    clearAnalyticsCookies();
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: "denied",
      });
    }
  }

  window.dispatchEvent(new CustomEvent(CONSENT_EVENT_NAME, { detail: { status } }));
};

const hasAnalyticsConsent = () => getConsentStatus() === CONSENT_STATUS_ACCEPTED;
const resetConsentStatus = () => setConsentStatus(CONSENT_STATUS_UNSET);

export {
  CONSENT_EVENT_NAME,
  CONSENT_STATUS_ACCEPTED,
  CONSENT_STATUS_REJECTED,
  CONSENT_STATUS_UNSET,
  getConsentStatus,
  hasAnalyticsConsent,
  resetConsentStatus,
  setConsentStatus,
};